import axios from 'axios';

export const fetchTranslation = (teamId: string) => {
  const path = `/api/teams/${teamId}/jobs/translation`;
  return axios.get(path);
};

export const updateTranslation = (teamId: string, payload: unknown) =>
  axios.patch(`/api/teams/${teamId}/jobs/translation`, payload);
